import { FC, useContext, useMemo } from "react";
import { EcdGenerateReportContext } from "../contexts/EcdGenerateReportContext";

const FiltersExport: FC = () => {
  const wizardContext = useContext(EcdGenerateReportContext);
  const displayFilters = wizardContext.displayFilters;
  const title = "Filters Applied";
  const maximumFiltersDisplayed = 15;

  const truncatedFiltersDisplay = useMemo(() => {

    const allFiltersText = "All Filters Selected"

    if (displayFilters.tags.length == displayFilters.tagsTotal) {
      displayFilters.tags = [];
      displayFilters.tags.push(allFiltersText);
    }
    else if (displayFilters.tags.length > maximumFiltersDisplayed) {
      truncateData(displayFilters.tags);
      displayFilters.tags = displayFilters.tags.map(tag => truncateText(tag));
    }
    else {
      displayFilters.tags = displayFilters.tags.map(tag => truncateText(tag));
    }

    if (displayFilters.counties.length > maximumFiltersDisplayed) {
      truncateData(displayFilters.counties);
      displayFilters.counties = displayFilters.counties.map(county => truncateText(county));
    }
    else {
      displayFilters.counties = displayFilters.counties.map(county => truncateText(county));
    }

    if (displayFilters.specialties.length == displayFilters.specialtyTotal) {
      displayFilters.specialties = [];
      displayFilters.specialties.push(allFiltersText);
    }
    else if (displayFilters.specialties.length > maximumFiltersDisplayed) {
      truncateData(displayFilters.specialties);
      displayFilters.specialties = displayFilters.specialties.map(specialty => truncateText(specialty));
    }
    else {
      displayFilters.specialties = displayFilters.specialties.map(specialty => truncateText(specialty));
    }

    if (displayFilters.includedProjects.length == displayFilters.includedProjectsTotal) {
      displayFilters.includedProjects = [];
      displayFilters.includedProjects.push(allFiltersText);
    }
    else if (displayFilters.includedProjects.length > maximumFiltersDisplayed) {
      truncateData(displayFilters.includedProjects);
      displayFilters.includedProjects = displayFilters.includedProjects.map(includedProject => truncateText(includedProject));
    }
    else {
      displayFilters.includedProjects = displayFilters.includedProjects.map(includedProject => truncateText(includedProject));
    }

    if (displayFilters.excludedProjects.length > maximumFiltersDisplayed) {
      truncateData(displayFilters.excludedProjects);
      displayFilters.excludedProjects = displayFilters.excludedProjects.map(excludedProject => truncateText(excludedProject));
    }
    else {
      displayFilters.excludedProjects = displayFilters.excludedProjects.map(excludedProject => truncateText(excludedProject));
    }

    return displayFilters;

  }, [wizardContext.displayFilters])

  function truncateData(data: string[]) {
    data.length = maximumFiltersDisplayed;
    data.push("...");
  }

  //text-overflow is not supported with Html2Canvas so we'll do it ourselves
  function truncateText(filter: string) {
    const maxCharLength = 15;
    if (filter.length >= maxCharLength) {
      let newFilter = filter.substring(0, maxCharLength);
      newFilter = newFilter + "...";
      return newFilter;
    }
    else {
      return filter;
    }
  }

  return (
    <div className="ecd-export__wrapper">
      <div style={{ display: "flex" }}>
        <h2 className="qes-dashboard-tile__title ecd-export__head">{title}</h2>
      </div>
      <br />
      <div className="d-flex dashboard-filters-overview__list">
          <span className="ecd-export-filters__label">Tag:</span>
          <span>{truncatedFiltersDisplay.tags.map((filter) => <span key={filter} className="dashboard-filters-overview__filter ecd-export-filters__tag">{filter}</span>)}</span>
        </div>
        <div className="d-flex dashboard-filters-overview__list">
          <span className="ecd-export-filters__label">Line of Business:</span>
          <span>{truncatedFiltersDisplay.lineOfBusiness.map((filter) => <span key={filter} className="dashboard-filters-overview__filter ecd-export-filters__tag">{filter}</span>)}</span>
        </div>
        <div className="d-flex dashboard-filters-overview__list">
          <span className="ecd-export-filters__label">State - All Licensed Counties:</span>
          <span>{truncatedFiltersDisplay.states.map((filter) => <span key={filter} className="dashboard-filters-overview__filter ecd-export-filters__tag">{filter}</span>)}</span>
        </div>
        <div className="d-flex dashboard-filters-overview__list">
          <span className="ecd-export-filters__label">County:</span>
          <span>{truncatedFiltersDisplay.counties.map((filter) => <span key={filter} className="dashboard-filters-overview__filter ecd-export-filters__tag">{filter}</span>)}</span>
        </div>
        <div className="d-flex dashboard-filters-overview__list">
          <span className="ecd-export-filters__label">Specialty:</span>
          <span>{truncatedFiltersDisplay.specialties.map((filter) => <span key={filter} className="dashboard-filters-overview__filter ecd-export-filters__tag">{filter}</span>)}</span>
        </div>
        <div className="d-flex dashboard-filters-overview__list">
          <span className="ecd-export-filters__label">County Status:</span>
          <span>{truncatedFiltersDisplay.countyStatuses.map((filter) => <span key={filter} className="dashboard-filters-overview__filter ecd-export-filters__tag">{filter}</span>)}</span>
        </div>
        <div className="d-flex dashboard-filters-overview__list">
          <span className="ecd-export-filters__label">Project - Applied:</span>
          <span>{truncatedFiltersDisplay.includedProjects.map((filter) => <span key={filter} className="dashboard-filters-overview__filter ecd-export-filters__tag">{filter}</span>)}</span>
        </div>
        <div className="d-flex dashboard-filters-overview__list">
          <span className="ecd-export-filters__label">Project - Excluded by Selected Tags:</span>
          <span>{truncatedFiltersDisplay.excludedProjects.map((filter) => <span key={filter} className="dashboard-filters-overview__filter ecd-export-filters__tag">{filter}</span>)}</span>
        </div>
    </div>
  );
}

export default FiltersExport;